import run from '../../utilities/run';
import $ from 'jquery';
import _ from "underscore";
import {isPresent} from "../../utilities/general";
import {combineElements} from "../../utilities/selectorHelpers";
import addressValidationFactory from '../common/AddressValidation.js';
import AsnStore from '../../stores/AsnStore';
import AbilityStore from '../../stores/AbilityStore';
import AddressEventBus from '../common/AddressEventBus';
import NewFacility from './Facility.js';

export default function LocationTab(wizard){
  const self = this;
  const portletNamespace = $("#asn-portlet-namespace").data("namespace").trim();
  const savedLocationsSelect =  $("#"+portletNamespace+"cmrAddresses");
  let savedLocationsList = savedLocationsSelect.data('options');
  const saveLocationUrl = $("#create-asn-form").data("save-location-url");
  const asnId  = $("#create-asn-form").data("asn-id");
  const asnCadId  = $("#create-asn-form").data("asn-cad-id");
  const asnFacId = $("#create-asn-form").data("asn-fac-id");
  const wizardEl = $("#create-asn-form");
  const tab = wizardEl.find(".location-tab");
  const originFacAddress = tab.find("#origin-fac-address");
  const originFacAddressWrapper = tab.find("#origin-fac-address-wrapper");
  const destFacAddressWrapper = tab.find("#dest-fac-address-wrapper");
  const destFacAddress = tab.find("#dest-fac-address");
  const facUsesList = tab.find("#fac-uses-list");
  const allSelects = tab.find("select");
  const addNewFacility = tab.find("#add-new-facility");
  const countries = $("#create-asn-form").data("countries");
  const isManufacturerUser = wizardEl.data("is-manufacturer-user");

  const facilitiesSelect = $("#"+portletNamespace+"facilities");
  const facilitiesList = facilitiesSelect.data('options');

  self.init = function(){
    const MyNewFacility = new NewFacility;
    MyNewFacility.init();
  };

  if(isManufacturerUser) {
      addNewFacility.hide();
  }

  $(savedLocationsList).each(function(){
    const option = $('<option />');
    option.attr('value', this.cadId).text(this.cadLocationName);
    savedLocationsSelect.append(option);
  });

  $(facilitiesList).each(function() {
    const option = $('<option />');
    option.attr('value', this.facId).text(this.facName);
    facilitiesSelect.append(option);
  });


  $(savedLocationsSelect).change(function() {
    const selectedValue = this.value;
    const senderAddress = savedLocationsSelect.data('options').filter(function(obj) { return obj.cadId==selectedValue; })[0];
    //show address
    let asnWithPallet = AsnStore.getOrCreateAsnWithShippingMethod("pallet");
    let asnWithParcel = AsnStore.getOrCreateAsnWithShippingMethod("parcel");
    originFacAddressWrapper.hide();
    originFacAddress.html('');
    if (senderAddress != null) {
      $("#"+portletNamespace+"cadId").val(senderAddress.cadId);
      originFacAddress.append("<div>"+senderAddress.cadAddress1+"</div>");
      if(senderAddress.cadAddress2 != null){
        originFacAddress.append("<div>"+senderAddress.cadAddress2+"</div>");
      }
      originFacAddress.append("<div>");
      if(senderAddress.cadCity != null){
        originFacAddress.append(senderAddress.cadCity);
      }
      if(senderAddress.cadState != null){
        originFacAddress.append(","+senderAddress.cadState);
      }
      if(senderAddress.cadZipcode != null){
        originFacAddress.append(","+senderAddress.cadZipcode);
      }
      originFacAddress.append("</div>");
      
	    let asn = getAsn();
      if(senderAddress.cadCountry != "US"){
        asn.isInternaltional = true;
      }else{
        asn.isInternaltional = false;
      }
      AsnStore.updateObjectAndEmit(asn.id, asn);

      $(countries).each(function() {
        if(this.conCode == senderAddress.cadCountry){
          originFacAddress.append("<div data-concode='"+this.conCode+"'>"+this.conName+"</div>");
          return;
        }
      });
      originFacAddressWrapper.show();
    }
  });

  $(facilitiesSelect).change(function() {
    const selectedFacility = this.value;
    const facility = facilitiesList.filter(function(obj) {
      return obj.facId==selectedFacility; }) [0];
    //show address
    destFacAddressWrapper.hide();
    destFacAddress.html('');
    if (facility != null) {
      $("#"+portletNamespace+"facId").val(facility.facId);
      destFacAddress.append("<div>"+facility.facAddressLine1+"</div>");
      if(facility.facAddressLine2 != null){
        destFacAddress.append("<div>"+facility.facAddressLine2+"</div>");
      }

      //destFacAddress.append("<div>"+facility.facCity+", "+facility.facState+" "+facility.facZipcode+"</div>");

      destFacAddress.append("<div>");
      
      if(facility.facCity!=null){
        destFacAddress.append(facility.facCity);  
      }

      if(facility.facState!=null){
       destFacAddress.append(","+facility.facState);
      }
      
      if(facility.facZipcode!=null){
        destFacAddress.append(","+facility.facZipcode);
      }
      destFacAddress.append("</div>");
      //show facility/fulfillment uses
      facUsesList.html("");
      facUsesList.append("<div class='q-boldest'>Facility Uses:</div>");
      var facilityUses = false;
      if(facility.attributes != null && facility.attributes.length > 0){
        $.each(facility.attributes[0],function(key, value) {
          if(key == "IN" && value == true){
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
            facilityUses = true;
          }else if(key == "FC" && value == true){
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
            facilityUses = true;
          }else if(key == "DC" && value == true){
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
            facilityUses = true;
          }else if(key == "RC" && value == true){
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
            facilityUses = true;
          }
        });
        if(!facilityUses){
          facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
        }
      }else{
        facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
      }
      destFacAddressWrapper.show();
    }
  });

  addNewFacility.click(function() {
    $("#asn-wizard-add-facility-Modal").modal('show');
  });

  if(asnId != null && asnId > 0) {
    savedLocationsSelect.val(asnCadId);
    savedLocationsSelect.trigger('change');
    determineDisabledInputs();
    facilitiesSelect.prop('disabled', true);
		facilitiesSelect.val(asnFacId).trigger('change');
  }else{
    facilitiesSelect.trigger('change');
  }

  function determineDisabledInputs(){
    const disabled = !AbilityStore.ask("canEditGtlAsn");
    const inputs = combineElements([savedLocationsSelect, facilitiesSelect, addNewFacility]);
    inputs.attr('disabled', disabled);
    allSelects.trigger("change.select2");
    if(disabled){
      addNewFacility.unbind('click');
    }
  }

  function getAsn(){
    if(isPallet())
      return AsnStore.getOrCreateAsnWithShippingMethod("pallet");
    else
      return AsnStore.getOrCreateAsnWithShippingMethod("parcel");
  }

  function getShippingMethod(){
    return AsnStore.getShippingMethod();
  }

  function isParcel(){
    return getShippingMethod() === 'parcel';
  }

  function isPallet(){
    return getShippingMethod() === 'pallet';
  }

}



// WEBPACK FOOTER //
// ./src/pages/asns/LocationTab.js